var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('main-header',{attrs:{"nowtab":"group"}}),_c('main',{staticClass:"adjuster"},[_c('div',[_c('div',{staticClass:"render-text",domProps:{"innerHTML":_vm._s(_vm.parse(_vm.introText))}})])]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }